"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import { Card, CardContent } from "@/components/ui/card";

interface FAQ {
  question: string;
  answer: string;
}

interface FaqTwoColumnProps {
  title?: string;
  subtitle?: string;
  faqs: FAQ[];
}

const FaqTwoColumn = ({ title, subtitle, faqs }: FaqTwoColumnProps) => {
  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="py-24 px-6 bg-white">
      <div className="container max-w-5xl mx-auto">
        {/* Header */}
        {(title || subtitle) && (
          <div className="text-center mb-16 space-y-4">
            {title && (
              <BlurFade delay={0.1}>
                <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                  {title}
                </h2>
              </BlurFade>
            )}
            {subtitle && (
              <BlurFade delay={0.15}>
                <p className="text-foreground/60 text-lg max-w-2xl mx-auto">
                  {subtitle}
                </p>
              </BlurFade>
            )}
          </div>
        )}

        {/* Two-Column FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {faqs.map((faq, i) => (
            <BlurFade key={i} delay={0.15 + i * 0.04}>
              <Card className="border-0 bg-muted/50 hover:bg-muted transition-colors h-full">
                <CardContent className="p-6 space-y-3">
                  <h3 className="text-base font-bold text-foreground leading-snug">
                    {faq.question}
                  </h3>
                  <p className="text-foreground/60 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </CardContent>
              </Card>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqTwoColumn;
